export default "__VITE_ASSET__0d608b4b__"